module.exports = __webpack_public_path__ + "static/media/job_category_11.f556da3d.png";